<template>
  <div ref="container" class="prod-box__wrap">
    <figure class="prod-box__figure"> 
        <video ref="video" muted preload="none" :playsinline="false" :controls="false" :poster="product.thumbnailUrl">
          <source :src="product.prevVideo" type="video/mp4"/>
        </video>
      <div v-if="product.isPremium" class="premium-icon">
        <svg class="premium-icon__icon">
          <use xlink:href="#icon-gem-solid"></use>
        </svg>
        <p class="premium-icon__text">Premium</p>
      </div>
    </figure>
    <div class="prod-box__overlay prod-box__overlay--video">
      <div class="prod-box__text-wrap">
        <a :href="product.productUrl">
          <h2 class="prod-box__title">{{ product.name }}</h2>
        </a>
        <p class="prod-box__subtitle">{{ sku }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Plyr from "plyr"
import {Product} from "../../utils/types.ts";
import {computed, ComputedRef, onBeforeUnmount, onMounted, ref, Ref} from "vue";
import { onClickOutside } from '@vueuse/core'

interface Props {
  product: Product;
}

const props = defineProps<Props>()

const player: Ref<Plyr | null> = ref(null)
const video: Ref<HTMLElement | null> = ref(null)
const button: Ref<HTMLElement | null> = ref(null)
const container: Ref<HTMLElement | null> = ref(null)

async function initVideo() {
  if (!video.value) return
  player.value = await new Plyr(video.value)
  if (!player.value) return
  button.value = player.value.elements.buttons.play ? player.value.elements.buttons.play[0] : null
}
const sku: ComputedRef<string> = computed(()=>{
  return props.product.sku ? props.product.sku.split('-').slice(1).join('-') : ""
})

onClickOutside(container, () => {
  pauseVideo()
})

function handleButtonClick() {
  player.value?.play()
}

function pauseVideo() {
  if (!player.value) return
  player.value.pause()
}

onMounted(async () => {
  await initVideo()
  button.value?.addEventListener('click', handleButtonClick);
})

onBeforeUnmount(() => {
  button.value?.removeEventListener('click', handleButtonClick);
})
</script>
